"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const up = async (knex)=>{
    const hasColumn = await knex.schema.hasColumn('nc_filter_exp_v2', 'enabled');
    if (!hasColumn) {
        await knex.schema.alterTable('nc_filter_exp_v2', (table)=>{
            table.boolean('enabled').defaultTo(true);
        });
    }
};
const down = async (knex)=>{
    const hasColumn = await knex.schema.hasColumn('nc_filter_exp_v2', 'enabled');
    if (hasColumn) {
        await knex.schema.alterTable('nc_filter_exp_v2', (table)=>{
            table.dropColumn('enabled');
        });
    }
};
